import { render } from "./ScpmPagination.vue?vue&type=template&id=1ed985d9&scoped=true"
import script from "./ScpmPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ScpmPagination.vue?vue&type=script&setup=true&lang=js"

import "./ScpmPagination.vue?vue&type=style&index=0&id=1ed985d9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed985d9"],['__file',"src/components/scpm/common/ScpmPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ed985d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ed985d9', __exports__)) {
    api.reload('1ed985d9', __exports__)
  }
  
  module.hot.accept("./ScpmPagination.vue?vue&type=template&id=1ed985d9&scoped=true", () => {
    api.rerender('1ed985d9', render)
  })

}


export default __exports__